export enum RestrictionQueryKey {
  Primary = 'restrictions',
  ById = 'restrictions/:id',
}
